
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, AppNotification } from '../../services/notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  notificationService = inject(NotificationService);
  notifications = this.notificationService.notifications;

  getIconClass(type: string): string {
    switch (type) {
      case 'success': return 'fa-solid fa-circle-check';
      case 'error': return 'fa-solid fa-circle-exclamation';
      case 'warning': return 'fa-solid fa-triangle-exclamation';
      case 'info': return 'fa-solid fa-circle-info';
      default: return 'fa-solid fa-bell';
    }
  }

  getBgClass(type: string): string {
    switch (type) {
      case 'success': return 'bg-emerald-600/95 border-emerald-400';
      case 'error': return 'bg-rose-600/95 border-rose-400';
      case 'warning': return 'bg-amber-600/95 border-amber-400';
      case 'info': return 'bg-sky-600/95 border-sky-400';
      default: return 'bg-slate-700/95 border-slate-500';
    }
  }

  removeNotification(id: number) {
    this.notificationService.remove(id);
  }

  onActionClick(notification: AppNotification) {
      this.notificationService.handleAction(notification);
  }
}
